import axios from "axios";

const state = {
    carousels: [],
    allCarousels: []
};

const getters = {
    Carousels: (state) => state.carousels,
    AllCarousels: (state) => state.allCarousels
};

const actions = {
    async GetCarouselsToPublish({ commit }, lan) {
        await axios.get(`${process.env.VUE_APP_APIURL}carousels/${lan}/publish`)
          .then((response) => {
              commit("setCarousels", response.data);
          })
          .catch((error) => {
              console.log(error)
          });
    },

    async GetListCarousels({ commit }, lan) {
        await axios.get(`${process.env.VUE_APP_APIURL}carousels/${lan}/all`)
          .then((response) => {
              commit("setAllCarousels", response.data);
          })
          .catch((error) => {
              console.log(error)
          });
    },  

    async CreateCarousel({ commit }, body) {
        return await axios.post(`${process.env.VUE_APP_APIURL}carousels`, body)
          .then(response => {
            return response.data;
          })
          .catch((error) => {
              return false;
          });
    },  

    async UpdateCarousel({ commit }, { id, lan, body }) {
        return await axios.post(`${process.env.VUE_APP_APIURL}carousels/update/${id}/${lan}`, body)
          .then(response => {
            return response.data;
          })
          .catch((error) => {
            return false;
          });
    },     

    async UploadImage({ commit }, formData) {
        let id = formData.get('car_id');
        return await axios.post(`${process.env.VUE_APP_APIURL}carousels/upload/${id}`, formData)
          .then(() => {
            return true;
          })
          .catch((error) => {
              return false;
          });
    },

    GetCarousel({ commit }, id) {
      return axios.get(`${process.env.VUE_APP_APIURL}carousels/${id}`)
        .then(response => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
    }, 

    async UpdateOrder({ commit }, body) {
      await axios.post(`${process.env.VUE_APP_APIURL}carousels/reorder`, body)
        .then((response) => {
            commit("setAllCarousels", response.data);
        })
        .catch((error) => {
            console.log(error)
        });
    },

    async DeleteCarousel({ commit, rootState }, id) {
        console.log('rootState', rootState.carouselModule.allCarousels)
        await axios.post(`${process.env.VUE_APP_APIURL}carousels/delete/${id}`)
          .then(res => {
              if(res.data.success){
                let carousels = rootState.carouselModule.allCarousels;
                var flist = carousels.filter(function(list_item) {
                    return list_item.car_id != id;
                });          
                commit("setAllCarousels", flist);
              }
          })
          .catch((error) => {
              console.log(error)
          });
      }    
}

const mutations = {
    setCarousels(state, carousels) {
        state.carousels = carousels;
    },
    setAllCarousels(state, carousels) {
        state.allCarousels = carousels;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};